<template>
    <div id="body">
        <div id="content">
            <div id="content-inner">
                <rkm-application>
                    <template>    
                        <rkm-navbar
                            :open="true"
                            class="rkm-navbar"
                        >
                            <rkm-navbar-brand class="ml-3">
                                <span>ConectaSUS</span>
                            </rkm-navbar-brand>
                        </rkm-navbar> 

                        <rkm-main :open="open">
                            <slot />
                        </rkm-main>
                    </template>
                </rkm-application>
            </div>
        </div>
    </div>        
</template>

<script>

// Mixins.
import { repository } from '@/mixins'

// Others.
import packageJSON from '/package.json'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            open: 'getSidebar',
        }),
    },
    created() {
        this.packageJSON = packageJSON

    },
    data: () => ({
        packageJSON: null,
    }),
    methods: {
        ...mapActions([
            'setSidebar',
        ]),
        handleToggle() {
            this.setSidebar(!this.open)
        },
    },
    mixins: [repository],
}
</script>

<style scoped>
.rkm-navbar {
    color: #ffffff !important;
}
.rkm-navbar-nav >>> .nav-link {
    color: #ffffff;
}

.rkm-main {
    padding-left: 0!important;
}

</style>